import * as Yup from "yup";
import { emailRegex, phoneRegex } from "../../../utility/constants";

export const carBodyTypeValidation = Yup.object({
  type_name: Yup.string().required("Vehicle type name is required"),
  type_url: Yup.string().required("Url is required")
});
